import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { BaseContext } from "./BaseContext";
export var DummyContext = /*#__PURE__*/function (_BaseContext) {
  _inherits(DummyContext, _BaseContext);

  var _super = _createSuper(DummyContext);

  function DummyContext() {
    var _this;

    _classCallCheck(this, DummyContext);

    _this = _super.apply(this, arguments);
    _this.lookAhead = 0;
    _this.latencyHint = 0;
    _this.isOffline = false;
    return _this;
  } //---------------------------
  // BASE AUDIO CONTEXT METHODS
  //---------------------------


  _createClass(DummyContext, [{
    key: "createAnalyser",
    value: function createAnalyser() {
      return {};
    }
  }, {
    key: "createOscillator",
    value: function createOscillator() {
      return {};
    }
  }, {
    key: "createBufferSource",
    value: function createBufferSource() {
      return {};
    }
  }, {
    key: "createBiquadFilter",
    value: function createBiquadFilter() {
      return {};
    }
  }, {
    key: "createBuffer",
    value: function createBuffer(_numberOfChannels, _length, _sampleRate) {
      return {};
    }
  }, {
    key: "createChannelMerger",
    value: function createChannelMerger(_numberOfInputs) {
      return {};
    }
  }, {
    key: "createChannelSplitter",
    value: function createChannelSplitter(_numberOfOutputs) {
      return {};
    }
  }, {
    key: "createConstantSource",
    value: function createConstantSource() {
      return {};
    }
  }, {
    key: "createConvolver",
    value: function createConvolver() {
      return {};
    }
  }, {
    key: "createDelay",
    value: function createDelay(_maxDelayTime) {
      return {};
    }
  }, {
    key: "createDynamicsCompressor",
    value: function createDynamicsCompressor() {
      return {};
    }
  }, {
    key: "createGain",
    value: function createGain() {
      return {};
    }
  }, {
    key: "createIIRFilter",
    value: function createIIRFilter(_feedForward, _feedback) {
      return {};
    }
  }, {
    key: "createPanner",
    value: function createPanner() {
      return {};
    }
  }, {
    key: "createPeriodicWave",
    value: function createPeriodicWave(_real, _imag, _constraints) {
      return {};
    }
  }, {
    key: "createStereoPanner",
    value: function createStereoPanner() {
      return {};
    }
  }, {
    key: "createWaveShaper",
    value: function createWaveShaper() {
      return {};
    }
  }, {
    key: "createMediaStreamSource",
    value: function createMediaStreamSource(_stream) {
      return {};
    }
  }, {
    key: "createMediaElementSource",
    value: function createMediaElementSource(_element) {
      return {};
    }
  }, {
    key: "createMediaStreamDestination",
    value: function createMediaStreamDestination() {
      return {};
    }
  }, {
    key: "decodeAudioData",
    value: function decodeAudioData(_audioData) {
      return Promise.resolve({});
    } //---------------------------
    // TONE AUDIO CONTEXT METHODS
    //---------------------------

  }, {
    key: "createAudioWorkletNode",
    value: function createAudioWorkletNode(_name, _options) {
      return {};
    }
  }, {
    key: "rawContext",
    get: function get() {
      return {};
    }
  }, {
    key: "addAudioWorkletModule",
    value: function addAudioWorkletModule(_url, _name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "resume",
    value: function resume() {
      return Promise.resolve();
    }
  }, {
    key: "setTimeout",
    value: function setTimeout(_fn, _timeout) {
      return 0;
    }
  }, {
    key: "clearTimeout",
    value: function clearTimeout(_id) {
      return this;
    }
  }, {
    key: "setInterval",
    value: function setInterval(_fn, _interval) {
      return 0;
    }
  }, {
    key: "clearInterval",
    value: function clearInterval(_id) {
      return this;
    }
  }, {
    key: "getConstant",
    value: function getConstant(_val) {
      return {};
    }
  }, {
    key: "currentTime",
    get: function get() {
      return 0;
    }
  }, {
    key: "state",
    get: function get() {
      return {};
    }
  }, {
    key: "sampleRate",
    get: function get() {
      return 0;
    }
  }, {
    key: "listener",
    get: function get() {
      return {};
    }
  }, {
    key: "transport",
    get: function get() {
      return {};
    }
  }, {
    key: "draw",
    get: function get() {
      return {};
    },
    set: function set(_d) {}
  }, {
    key: "destination",
    get: function get() {
      return {};
    },
    set: function set(_d) {}
  }, {
    key: "now",
    value: function now() {
      return 0;
    }
  }, {
    key: "immediate",
    value: function immediate() {
      return 0;
    }
  }]);

  return DummyContext;
}(BaseContext);